import { aspenApi as api, getWalletSpotAccounts } from "@aspen/services";
import { generateDataCacheKey } from "@aspen/libs";
import { useQuery } from "@tanstack/react-query";
import { updateSpotAccountList, useAppDispatch } from "@aspen/store";

/**
 * 获取现货账户数据。
 */
export const useFetchSpotsAccount = () => {
  const apiPath = api.wallet.spot;
  const queryKey = generateDataCacheKey({ api: apiPath, params: "" });
  const dispatch = useAppDispatch();
  const { error, data, isLoading, refetch } = useQuery({
    queryKey: [queryKey],
    queryFn: () => {
      return getWalletSpotAccounts().then(res => {
        if (res?.code == "0") {
          dispatch(updateSpotAccountList(res?.data));
          return res.data;
        }
      });
    },
  });
  return { error, data, refetch, queryKey, isLoading };
};
